import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'projects/uzurv/src/app/material.module';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerifiedAddress } from 'projects/sdk/packages/dots/src/models/verified-address';
import { VerifiedAddressErrorConstants, Address } from '@uzurv/dots';
import { DriverState } from 'projects/uzurv/src/store/driver/driver.reducer';
import { State, Store } from '@ngrx/store';
import * as DriverActions from 'projects/uzurv/src/store/driver/driver.actions';
import { Driver } from '@uzurv/clara';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';

export interface AddressValidationDialogData {
  driver: Driver;
  verifiedAddress: VerifiedAddress;
}

@Component({
  selector: 'app-address-validation-dialog',
  templateUrl: './address-validation-dialog.component.html',
  styleUrls: ['./address-validation-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MaterialModule],
  providers: [
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'primary' }
    }
  ]
})
export class AddressValidationDialogComponent implements OnInit {
  readonly verifiedAddressErrorConstants = VerifiedAddressErrorConstants;
  selectedAddressControl = new FormControl();
  currentValidationStatus: string;
  confirmedAddress: Address;

  constructor(
    private dialogRef: MatDialogRef<AddressValidationDialogComponent>,
    private store$: Store<State<DriverState>>,
    @Inject(MAT_DIALOG_DATA) public data: AddressValidationDialogData
  ) {}

  ngOnInit(): void {
    this.initializeComponent();
    this.setupAddressSubscription();
  }

  handleBackToEditAddress(): void {
    this.dialogRef.close();
    this.store$.dispatch(
      DriverActions.OpenEditDriverProfileDialog({
        driver: this.data.driver,
        address: this.data.verifiedAddress.requestedAddress
      })
    );
  }

  handleSubmitAddress(): void {
    this.dialogRef.close();
    this.store$.dispatch(
      DriverActions.EditDriverProfile({
        driver: this.data.driver,
        address: this.confirmedAddress,
        displayAddressValidationDialog: false
      })
    );
  }

  private initializeComponent(): void {
    this.currentValidationStatus = this.data.verifiedAddress.error;
    this.initializeSavedAddress();
    this.selectedAddressControl.setValue(this.confirmedAddress);
  }

  private initializeSavedAddress(): void {
    if (
      this.currentValidationStatus === VerifiedAddressErrorConstants.MISMATCH &&
      this.data.verifiedAddress.suggestedAddresses.length > 0
    ) {
      this.confirmedAddress = this.data.verifiedAddress.suggestedAddresses[0];
    }
  }

  private setupAddressSubscription(): void {
    this.selectedAddressControl.valueChanges.subscribe((address: Address) => {
      this.confirmedAddress = address;
    });
  }
}
